export enum Contants {
  LINK_YOUTUBE = "https://www.youtube.com/channel/UC2t-2rxSVoy7VYoAb0WDFRg?view_as=subscribercriber",
  LINK_FACEBOOK = "https://www.facebook.com/app.suplementossaude/",
  LINK_INSTAGRAM = "https://www.instagram.com/app.suplementossaude/",
  LINK_SHARE = "http://www.suplementossaude.net.br/",
}

export enum ActionButton {
  ACTION_SITE = "site",
  ACTION_PHONE = "phone",
  ACTION_MAP = "map",
  ACTION_EMAIL = "email",
  ACTION_ZAP = "zap",
  ACTION_SHARE = "share",
  ACTION_VIDEO = "video",
  ACTION_LIKE = "like",
}
